module.exports = __webpack_public_path__ + "img/1504555959.e9318fd4.jpg";